import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cilPlus,
  cibGithub,
  cilArrowLeft,
  cilHandPointUp,
  cilHandPointDown,
  cilInstitution,
  cibStackoverflow,
  cibYoutube,
  cilMobile,
  cilBriefcase,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cilFrown,
  cilMeh,
  cilWallet,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cilHappy,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
} from "@coreui/icons";
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from "@coreui/icons";
import {
  cilArrowRight,
  cilBan,
  cilBasket,
  cilTrash,
  cilSwapHorizontal,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilDescription,
  cilMap,
  cilChartPie,
  cilLeaf,
  cilSearch,
  cilCheck,
  cilChevronBottom,
  cilCalendarCheck,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilMoney,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilHome,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilLifeRing,
  cilPlant,
  cilTag,
  cilCloudUpload,
  cilLibraryBuilding,
  cilRunning,
  cilHeadphones,
  cilReload,
  cilSave,
} from "@coreui/icons";

export const iconsSet = Object.assign(
  {},
  {
    cilHeadphones,
    cilRunning,
    cilLibraryBuilding,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilHandPointUp,
    cilHandPointDown,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilHome,
    cilArrowLeft,
    cilCheck,
    cilWallet,
    cilInstitution,
    cilPlus,
    cilHappy,
    cilLeaf,
    cilFrown,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilBriefcase,
    cilCommentSquare,
    cilMobile,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilMeh,
    cilGlobeAlt,
    cilGrid,
    cilSwapHorizontal,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMoney,
    cilMap,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilDescription,
    cilPencil,
    cilPeople,
    cilSearch,
    cilTrash,
    cilPuzzle,
    cilSettings,
    cilCalendarCheck,
    cilShieldAlt,
    cilSpeech,
    cilSave,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
    cilLifeRing,
    cilPlant,
    cilTag,
    cilCloudUpload,
    cilReload,
  }
);
